<div class="card">
  <!-- Header -->
  <div class="border-b border-gray-200 dark:border-gray-700 pb-4 mb-4">
    <h4 class="text-lg font-semibold text-gray-800 dark:text-gray-100">
      Capital Fax
    </h4>
  </div>

  <!-- Body -->
  <div class="space-y-4">
    <div class="card">
      <div class="border-b border-gray-200 dark:border-gray-700 pb-3 mb-3">
        <h5 class="text-md font-medium text-gray-700 dark:text-gray-200">
          Capital Fax Window
        </h5>
      </div>
      <div class="text-gray-600 dark:text-gray-300">
        Your Capital Fax has been created
      </div>
    </div>
  </div>
</div>
